<template>
	<section class="margin-both-lg">
		<div class="inner container margin-auto">
			<h2 class="module-title" v-if="data.module_title" v-html="data.module_title"></h2>
			<div class="filters margin-bottom-lg margin-top-lg" v-if="filterToUse && data.list_type === 'all'">
				<div class="select-container" :class="{ focus: selectFocus }">
					<select
						name="filters"
						v-model="currentFilters"
						@focus="selectFocus = true"
						@blur="selectFocus = false"
					>
						<option value="" selected>{{ filterButtonText }}</option>
						<option v-for="filter in filterToUse" :key="filter.id" :value="filter.id">
							{{ filter.name }}
						</option>
					</select>
					<svg width="15" height="10" xmlns="http://www.w3.org/2000/svg">
						<path
							fill="var(--dark)"
							d="M15 1.769L13.231 0 7.5 5.731 1.769 0 0 1.769l7.5 7.5 7.5-7.5z"
							fill-rule="evenodd"
						/>
					</svg>
				</div>
			</div>
			<transition-group
				:style="{ '--totalStagger': postsToShow.length }"
				tag="div"
				class="nhk-items"
				name="slide-in"
				v-if="postsToShow && postsToShow.length"
				appear
			>
				<NHKItem
					v-for="(post, i) in postsToShow.slice(0, showLimit * page)"
					:data="post"
					:style="{ '--indexStagger': staggingNum(i) }"
					:key="post.id"
				/>
			</transition-group>
		</div>
		<div
			v-show="postsToShow && postsToShow.length > showLimit * page"
			class="button-load text-center margin-top-lg"
		>
			<Button
				type="black"
				:has-icon="false"
				:outlined="false"
				uppercase
				v-observe-visibility="visibilityChanged"
				@click.native="loadMore"
			>
				Last mer
			</Button>
		</div>
	</section>
</template>

<script>
import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'
//

import NHKItem from '@/components/parts/NHKItem'
import Button from '@/components/elements/Button'

export default {
	props: ['data'],
	data() {
		return {
			currentFilters: '',
			selectFocus: false,
			showLimit: 6,
			page: 1,
		}
	},
	computed: {
		...mapGetters(['servicesLoaded', 'marketsLoaded', 'getServices', 'getMarkets']),
		filterButtonText() {
			return this.data.filter_button_name || 'Sorter'
		},
		moduleFilterPosts() {
			if (this.data.archive_block_type !== 'services') {
				return this.getServices
			} else {
				return this.getMarkets
			}
		},
		modulePosts() {
			let posts = []
			if (this.data.archive_block_type === 'services') {
				posts = [...this.getServices]
			} else {
				posts = [...this.getMarkets]
			}

			return posts && posts.length
				? posts.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }))
				: []
		},
		postsToShow() {
			if (this.modulePosts && this.modulePosts.length) {
				let posts = this.modulePosts.filter((post) => {
					//backend selected
					if (this.data.list_type === 'selected' && post.acf) {
						if (this.data.archive_block_type === 'services') {
							return this.data.selected_services.includes(post.id)
						} else {
							return this.data.selected_market.includes(post.id)
						}
					}

					//based on selected categories
					if (this.data.list_type === 'category' && post.acf) {
						if (this.data.archive_block_type === 'services') {
							return (
								post.acf.related_market &&
								post.acf.related_market.some((e) => this.data.category_marketing.includes(e))
							)
						} else if (post.acf) {
							return (
								post.acf.related_services &&
								post.acf.related_services.some((e) => this.data.category_services.includes(e))
							)
						}
					}

					if (this.currentFilters && post.acf) {
						if (this.data.archive_block_type === 'services') {
							return post.acf.related_market && post.acf.related_market.includes(this.currentFilters)
						} else if (this.currentFilters) {
							const service = this.moduleFilterPosts.find((p) => p.id === this.currentFilters)
							return (
								service &&
								service.acf &&
								service.acf.related_market &&
								service.acf.related_market.includes(post.id)
							)
						}
					}

					return true
				})

				return posts && posts.length ? posts : []
			} else {
				return []
			}
		},
		filterToUse() {
			if (this.moduleFilterPosts && this.moduleFilterPosts.length) {
				return this.moduleFilterPosts
					.map((e) => {
						return { name: e.title, id: Number(e.id) }
					})
					.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
			} else {
				return false
			}
		},
	},
	components: {
		NHKItem,
		Button,
	},
	mounted() {
		const VM = this
		if (!VM.data) return false

		this.loadServices()
		this.loadMarkets()
	},
	methods: {
		...mapActions(['loadServices', 'loadMarkets']),
		loadMore() {
			++this.page
		},
		visibilityChanged(isVisible) {
			if (isVisible && this.data.load_on_scroll) {
				this.loadMore()
			}
		},
		staggingNum(i) {
			let num = i
			if (this.page > 1) {
				num = num - this.showLimit * (this.page - 1)
			}
			return num
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-archive_block {
	.module-title {
		margin-bottom: 50px;
		@include mquery($tablet) {
			margin-bottom: 30px;
		}
	}
	.select-container {
		position: relative;
		display: inline-block;
		@include mquery($phone) {
			width: 100%;
		}
		&.focus {
			svg {
				transform: translateY(-50%) rotate(180deg);
			}
		}
		select {
			cursor: pointer;
			border: 2px solid var(--dark);
			-webkit-appearance: none;
			background: transparent;
			color: var(--dark);
			text-transform: uppercase;
			padding: 13px 20px;
			padding-right: 58px;
			@include fluid-type($smallResText, $wideResText, 16px, 24px);
			option {
				background-color: var(--light);
			}
			@include mquery($tablet) {
				padding: 10px 15px;
				padding-right: 50px;
			}
			@include mquery($phone) {
				width: 100%;
			}
		}
		svg {
			position: absolute;
			top: 50%;
			right: 25px;
			transform: translateY(-50%);
			transition: transform 0.1s ease-in-out;
			pointer-events: none;
		}
	}
}
.nhk-items {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	bottom: -25px;
	margin: 0 -25px;
	margin-top: -25px;
	.nhk-item {
		min-width: 50%;
		max-width: 50%;
		padding: 25px;
	}
	@include mquery($tablet) {
		bottom: -12.5px;
		margin: 0 -12.5px;
		margin-top: -25px;
		.nhk-item {
			padding: 12.5px;
		}
	}
	@include mquery($phone) {
		bottom: 0;
		.nhk-item {
			max-width: 100%;
			min-width: 100%;
			padding-bottom: 0px;
			padding-top: 15px;
		}
	}
}
</style>
